import { apiClient, type ApiResponse } from "./apiClient";

export interface GlobalTenantConfig {
  module_id: number;
  module_name: string;
  /** User-facing module label (breadcrumbs, page title). Falls back when absent. */
  module_display_name?: string | null;
  max_value_per_concept: number;
  max_tasks: number;
  max_user_filters: number;
  max_concepts_per_user_filter: number;
  max_user_checklists: number;
  max_checklist_concepts: number;
  max_keyword_length: number;
  max_regulations_per_batch: number;
}

export type GlobalTenantConfigResponse = ApiResponse<GlobalTenantConfig>;

export async function fetchGlobalTenantConfig(): Promise<GlobalTenantConfigResponse> {
  return apiClient.get<GlobalTenantConfig>("/global/config");
}

